module.exports = __webpack_public_path__ + "static/media/s0sx266kgwcied2w.8d534f74.png";